import { useCallback } from 'react';
import { useAppDispatch } from '../store';
import { selectPill, selectRadio, selectSelect } from '../store/app';
import { PILL, RADIO, SELECT, TOGGLE } from '../utils';
export const useSelectOption = () => {
    const dispatch = useAppDispatch();
    return useCallback((id, value, type, selectedIndex, icf) => {
        if (type === PILL) {
            dispatch(selectPill({
                id,
                value,
                tags: icf || []
            }));
        }
        else if (type === RADIO) {
            dispatch(selectRadio({
                id,
                value
            }));
        }
        else if (type === SELECT || type === TOGGLE) {
            dispatch(selectSelect({
                id,
                value,
                selectedIndex: selectedIndex || 0
            }));
        }
    }, [dispatch]);
};
//# sourceMappingURL=useSelectOption.js.map